import { PageBlock } from '@design-system/page-block';
import { RetailersBlock } from '@design-system/retailers-block';
import { setLocalStorageData } from '@phx-husky/local-storage';
import React from 'react';

import { gtmService } from '~/services/gtm';
import { GTM_LOCALSTORAGE_DATA } from '~/utils/constants';

import { RetailersPageBlockProps } from './models';

const RetailersPageBlock = ({
  pageBlock,
  componentId,
  retailers,
  uid,
}: RetailersPageBlockProps) => {
  const onClickRetailerName = (title: string, url: string) => {
    setLocalStorageData(GTM_LOCALSTORAGE_DATA.lastRetailerTitle, title);
    gtmService.emitRetailerClick(title, url);
  };

  return (
    <PageBlock
      {...pageBlock}
      id={componentId}
      className="retailers-block"
      componentUid={uid}
    >
      <RetailersBlock
        {...retailers}
        onClickRetailerName={onClickRetailerName}
      />
    </PageBlock>
  );
};

export default RetailersPageBlock;
